import { useEffect, useState, useRef } from 'react'
import {
    BuyNode,
    BuyNodeV2,
    NodeData,
    ApprovesUSDT,
    ApprovesCVCD,
    ApprovesCVC,
    ApprovesAIToken,
    Claim,
    ClaimCVC,
    StairData,
    SetOrder,
    BuyOrder,
    Swap,
    UserListOfStair,
    ClaimStair,
    SwapContract,
    SendCVC,
    SendCVCD,
    SendAIToken,
    Sends,
    StairOrderCheck
} from '../../chain/ma'

import {
    WeiToUnits,
    EtherToWei,
    ZERO_ADDRESS
} from '../../ethers/e'
import {
    useEthers,
    useBlockCall
} from '../../ethers'

import {
    isETHAddress,
    getUrlParams,
    getAddresses,
    randomInt
} from '../../utils'

import {
    Error
} from '../tools'

import useButtonText from '../useButtonText'
import useInput from '../useInput';
import useToast from '../useToast'

export function useStairData() {
    return useBlockCall(
        account => {
            return StairData(account)
        },
        StairData.Type
    )
}

export function useNodeData() {
    return useBlockCall(
        account => {
            return NodeData(account)
        },
        NodeData.Type
    )
}

export function useUserListOfStair() {
    return useBlockCall(
        () => {
            return UserListOfStair(100)
        },
        UserListOfStair.Type
    )
}

export function useBuyNode() {
    const sponsorInput = useInput("")
    const hashInput = useInput("")
    const amountInput = useInput("", {type:'number'})
    const {open} = useToast()
    const {
        button,
        loadingButton,
        initButton,
    } = useButtonText('Buy Node')

    useEffect(() => {
        const {r} = getUrlParams()
        if (r) sponsorInput.onChange(r)
    }, [])
    

    button.onClick = async () => {
        const sponsor = sponsorInput.value === "" ? ZERO_ADDRESS : sponsorInput.value
        if (!isETHAddress(sponsor)) {
            open("sponsor address error", "error")
            return
        }
        loadingButton('Pending')
        try {
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            loadingButton('Approve USDT')
            let {
                // nonce,
                tx,
                error
            } = await ApprovesUSDT()
            loadingButton('Pending')
            if (error) {
                open(Error(error), "error")
            }
            else {
                await tx.wait()
                tx = await BuyNodeV2(EtherToWei(amountInput.value), sponsor, hashInput.value)
                await tx.wait()
                amountInput.onChange("")
                open('Success')
            }
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return {
        button,
        hashInput,
        sponsorInput,
        amountInput
    }
}

export function useClaim() {
    const {open} = useToast()
    const {account} = useEthers()
    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText('Claim')

    button.onClick = async () => {
        loadingButton('Pending')
        let tx;
        try {
            tx = await Claim(account)
            await tx.wait()
            open('Success')
            initButton()
            return true
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
            initButton()
            return false
        }
    }

    return button
}

const whiteList = [
    // "0xE814a4C4A1fF570DfCfc67248549Ba01Ea8B86Df",
    // "0x95EEd2F6ec48E16508B8526E4230dC7F9e361e0f",
    // "0xb48ea7fce8C5DE098ec61A8Ab590c75FE332C60e",
    // "0xe38aAaddBEf893e50c4b0D0F093468eC4570Ca83",
    // "0x33B1fb57A42db47b4a7B8ff11beAe2c37e6345ad",
    // "0x053fDf5F01cA8c612c428d872A396aF321E9DD06",
    // "0x960Edf6dBd3687FDfc8c82e32E00Ad784BE0d303",
    // "0x845d8F1136d3d085F0AC1EDAA2d2a07d5ab6B920",
    // "0x0A339064517F22e30fF759EC6D73fE0b918bC0E4",

    // "0xF243b161091D12184762E4B768A51B05A2452E3C",
    // "0x3EaD8e4DbcBeE5a0f04031Fe894FB7dB9DE446E4",
    // "0x46E808BA486d1feEAC96c36c6184C41576B6e3c3",
    // "0xCf9BF4430D1BacbD91195630e134dE3A73689E16",
    // "0x23b3a29292EC3C48100D4de2aaCc9cB984B5C414",
    // "0x1366eF7ED067b39Eca9469ffdCf2C087Ca477B37",
    // "0x8194D50960E10034b6D576DC990d48BC881234a5",
    // "0xDF0534C6C875e27A7e9429e5f16530F5eF1B979B",
    // "0x407D50A01af0D8f5910fc20D23bF0901539920Af",
    // "0x17B8729d9c090B9b59f231328fCDAFe68F17df21",
    // "0x4205CA958da4615530E65c158fCABAA522aC5511",
    // "0xdB85CA11056B83E18DC37640c629eAA1646B360B",
    // "0x841Be3cC925D4cA97ed045999d42512fa17aF514",
    // "0xD9db3351EC1e70Deb51Fa8F04aAa63F359A0682a",
    // "0x3A4160A8069599cADBdd235f654e12f083411b1D",
    // "0xE42a73B2B0e9b33dE8F35FBFD32C6ACb27d2Dd02",
    // "0x2d68928Db1f37DAf00d90F4974b8A8F54172F497",
    // "0xc64DA9F66ef91e578475a28e5db8C97C4B175022",
    // "0xDa94B0Bb990EC53424738Ff7053381A70Dd61214",
    // "0x2ac0E3cE01E9Fb7dDBD1B0C74A4703516981677E",
    // "0xC63F3E437f86b99C4675E452bD7785FB07A62D98",
    // "0xDd54Fc2De322B545e25Cedb8B00bC7A620EB7bD8",
    // "0x8af22FA2cbE7E0493cffB7AE7E2A94b6b194fA87",
    // "0x0FFDfA8Bbd027589F71FEfd5f3Ee0dc5a0829C8e",
    // "0x9AB9Be26fdAB50625cB4D7671Edb635a72ae62F5",
    // "0x50E7Ad4D7b91DCbE5f74F03565E19A43573274a2",
    // "0x5205F7a3007E1668CC6EF9d037135Bf6F25e86a2",
    // "0x60c4feAe495BED48370B9c025fb8c2b4ff044eB4",
    // "0x2Dae998f9A98f3412064510E74fD733f44C75420",
    // "0x13E4D01087b881502d0CFc0CD7484cf86f3D773a",
    // "0x405735A51E06bb70e6AfC6beB1362969E2836e87",
    // "0x384d99528ad7c8F9BE1fE6e646837D63cB393ad2",
    // "0x7F3e814fd0D693FFa21337f008302F19afC5CD15",
    // "0xE824353fF463f64538CeE0FF47268833573D1e3D",
    // "0xA571678e4f5f0E359a96258FC12b183ec314dD07",
    // "0xa0E7b0A5Dab0D1Fa01E55aF7161CD345703D1A4d",

    // "0x1c9d7266b68A0A7436b9651928f795631F45dD6d",
    // "0x5029192E6ED6368823dF72dEbaCF64942b9D8039",
    // "0x0cB1a34d12DCF9a5727A536e1DDC2f3Af5233311",
    // "0x425404E04347C408311D01C4605352e9C226216b",

    // "0x8C63c671D18486B68093CCB5a86bE5DdED4d6769",
    // "0xdfEF911aD9E16526cBa68a0ba8b6F16b41B49f3B",
    // "0xE9badBeFe45c07fE1D180cd28043380e5E5e5F59",
    // "0xea1Ff0a47b611BA0556B972D12b0946A0B71266c",

]

export function useClaimCVC() {
    const {open} = useToast()
    const {account} = useEthers()
    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText('Claim')

    button.onClick = async () => {
        loadingButton('Pending')
        let tx;
        try {
            tx = await ClaimCVC(account)
            await tx.wait()
            open('Success')
            initButton()
            return true
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
            initButton()
            return false
        }
    }

    button.disabled = !whiteList.includes(account)

    return button
}

export function useReInvestOrder(id) {
    const {open} = useToast()
    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText('Vip+1')

    button.onClick = async () => {
        loadingButton('Pending')
        let tx;
        try {
            tx = await SetOrder(id, 1)
            await tx.wait()
            open('Success')
            initButton()
            return true
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
            initButton()
            return false
        }
    }

    return button
}

export function useWithdrawOrder(id) {
    const {open} = useToast()
    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText('Close')

    button.onClick = async () => {
        loadingButton('Pending')
        let tx;
        try {
            tx = await SetOrder(id, 0)
            await tx.wait()
            open('Success')
            initButton()
            return true
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
            initButton()
            return false
        }
    }

    return button
}



export function useBuyOrder() {
    const hashInput = useInput("")
    const sponsorInput = useInput("")
    const amountInput = useInput("", {type: 'number'})
    const {open} = useToast()

    const {
        button,
        loadingButton,
        initButton,
    } = useButtonText('USDT Buy')

    const {
        button: buttonCVCD,
        loadingButton: loadingButtonCVCD,
        initButton: initButtonCVCD,
    } = useButtonText('CVCD Buy')

    useEffect(() => {
        const {r} = getUrlParams()
        if (r) sponsorInput.onChange(r)
    }, [])

    buttonCVCD.onClick = async () => {
        if (!isETHAddress(sponsorInput.value)) {
            open("sponsor address error", "error")
            return
        }
        loadingButtonCVCD('Pending')
        try {
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            loadingButtonCVCD('Approve CVCD')
            let {
                // nonce,
                tx,
                error
            } = await ApprovesCVCD()
            loadingButtonCVCD('Pending')
            if (error) {
                open(Error(error), "error")
            }
            else {
                await tx.wait()
                
                const _amountWei = EtherToWei(amountInput.value)
                tx = await BuyOrder(1, _amountWei, sponsorInput.value, hashInput.value)
                await tx.wait()
                open('Success')
            }
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButtonCVCD()
    }

    button.onClick = async () => {
        if (!isETHAddress(sponsorInput.value)) {
            open("sponsor address error", "error")
            return
        }
        loadingButton('Pending')
        try {
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            loadingButton('Approve USDT')
            let {
                // nonce,
                tx,
                error
            } = await ApprovesUSDT()
            loadingButton('Pending')
            if (error) {
                open(Error(error), "error")
            }
            else {
                await tx.wait()
                
                const _amountWei = EtherToWei(amountInput.value)
                tx = await BuyOrder(0, _amountWei, sponsorInput.value, hashInput.value)
                await tx.wait()
                open('Success')
            }
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return {
        button,
        buttonCVCD,
        hashInput,
        amountInput,
        sponsorInput
    }
}


export function useSwap() {
    const amountInput = useInput("", {type: 'number'})
    const {open} = useToast()

    const {
        button,
        loadingButton,
        initButton,
    } = useButtonText('Swap to USDT')

    button.onClick = async () => {
        loadingButton('Pending')
        try {
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            loadingButton('Approve CVCD')
            let {
                // nonce,
                tx,
                error
            } = await ApprovesCVCD(
                SwapContract().address
            )
            loadingButton('Pending')
            if (error) {
                open(Error(error), "error")
            }
            else {
                await tx.wait()
                
                const _amountWei = EtherToWei(amountInput.value)
                tx = await Swap(_amountWei)
                await tx.wait()
                open('Success')
            }
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return {
        button,
        amountInput
    }

}





export function useClaimStair() {
    const {open} = useToast()
    const {account} = useEthers()
    const {
        button,
        loadingButton,
        initButton,
        // setButtonText,
        // setDisabled
    } = useButtonText('Claim')

    button.onClick = async () => {
        loadingButton('Pending')
        let tx;
        try {
            tx = await ClaimStair(account)
            await tx.wait()
            open('Success')
            initButton()
            return true
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
            initButton()
            return false
        }
    }

    return button
}

function toNumberFromInput(value) {
  if (typeof value !== "string") return 0;

  const v = value.trim();

  if (v === "") return 0;

  const num = Number(v);

  return Number.isFinite(num) ? num : 0;
}

export function useSendCVC() {
    const amountInput = useInput("", {type: 'number'})
    const {open} = useToast()

    const {
        button,
        loadingButton,
        initButton,
    } = useButtonText('Send CVC')

    button.onClick = async () => {
        let amount = toNumberFromInput(amountInput.value)
        if (amount <= 0) return
        amount = Math.floor(amount)
        loadingButton('Pending')

        // avoid to freen ui by getAddresses action
        const Create  = () => {
            return new Promise((r) => {
                setTimeout(() => {
                    let wallets = getAddresses(amount)
                    const amounts = []
                    wallets = wallets.map(v => {
                        amounts.push(
                            EtherToWei(randomInt(0.0001, 0.1))
                        )
                        return v.address
                    })
                    r([wallets, amounts])
                }, 0)
            })
        }
        const [wallets, amounts] = await Create()
        try {
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            loadingButton('Approve CVC')
            let {
                // nonce,
                tx,
                error
            } = await ApprovesCVC()
            loadingButton('Pending')
            if (error) {
                open(Error(error), "error")
            }
            else {
                await tx.wait()
                tx = await SendCVC(wallets, amounts)
                await tx.wait()
                open('Success')
            }
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return {
        button,
        amountInput
    }
}




export function useSendCVCD() {
    const amountInput = useInput("", {type: 'number'})
    const {open} = useToast()

    const {
        button,
        loadingButton,
        initButton,
    } = useButtonText('Send CVCD')

    button.onClick = async () => {
        let amount = toNumberFromInput(amountInput.value)
        if (amount <= 0) return
        amount = Math.floor(amount)
        loadingButton('Pending')

        // avoid to freen ui by getAddresses action
        const Create  = () => {
            return new Promise((r) => {
                setTimeout(() => {
                    let wallets = getAddresses(amount)
                    const amounts = []
                    wallets = wallets.map(v => {
                        amounts.push(
                            EtherToWei(randomInt(0.0001, 0.1))
                        )
                        return v.address
                    })
                    r([wallets, amounts])
                }, 0)
            })
        }
        const [wallets, amounts] = await Create()
        // console.log(
        //     wallets, amounts
        // )
        try {
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            loadingButton('Approve CVC')
            let {
                // nonce,
                tx,
                error
            } = await ApprovesCVCD(
                Sends().address
            )
            loadingButton('Pending')
            if (error) {
                open(Error(error), "error")
            }
            else {
                await tx.wait()
                tx = await SendCVCD(wallets, amounts)
                await tx.wait()
                open('Success')
            }
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return {
        button,
        amountInput
    }
}



export function useSendAIToken() {
    const amountInput = useInput("", {type: 'number'})
    const {open} = useToast()

    const {
        button,
        loadingButton,
        initButton,
    } = useButtonText('Send AIToken')

    button.onClick = async () => {
        let amount = toNumberFromInput(amountInput.value)
        if (amount <= 0) return
        amount = Math.floor(amount)
        loadingButton('Pending')

        // avoid to freen ui by getAddresses action
        const Create  = () => {
            return new Promise((r) => {
                setTimeout(() => {
                    let wallets = getAddresses(amount)
                    const amounts = []
                    wallets = wallets.map(v => {
                        amounts.push(
                            EtherToWei(randomInt(0.0001, 0.1, 15), 15)
                        )
                        return v.address
                    })
                    r([wallets, amounts])
                }, 0)
            })
        }
        const [wallets, amounts] = await Create()
        console.log(
            wallets, amounts
        )
        try {
            // uint _amountUSDG, uint _pId, address _sponsor, uint16[] calldata _unlockPids
            loadingButton('Approve AI')
            let {
                // nonce,
                tx,
                error
            } = await ApprovesAIToken(
                Sends().address
            )
            loadingButton('Pending')
            if (error) {
                open(Error(error), "error")
            }
            else {
                await tx.wait()
                tx = await SendAIToken(wallets, amounts)
                await tx.wait()
                open('Success')
            }
        } catch (e) {
            console.log(e)
            open(Error(e), "error")
        }
        initButton()
    }

    return {
        button,
        amountInput
    }
}



export function useStairOrderCheck() {
    const rootInput = useInput("")
    const {
        button,
        loadingButton,
        initButton,
    } = useButtonText('Check')
    const [orders, SetOrders] = useState(StairOrderCheck.Type)

    button.onClick = async () => {
        loadingButton()
        try {
            SetOrders(
                await StairOrderCheck(rootInput.value)
            )
        } catch(error) {
            console.log(
                error
            )
        }
        initButton()
    }

    return {
        rootInput,
        button,
        orders
    }
}